import axios, {
    AxiosError,
    AxiosInstance,
    AxiosRequestConfig,
    AxiosResponse
} from 'axios';
import {store} from "../../store";
import {setIsLoggedIn} from "../../features/User/userActions";

/**
 * Isomorphic httpInstance
 * @param baseUrl
 */
export const httpInstance = <T>(baseUrl: string) => {
    const requestOptions: AxiosRequestConfig = {
        baseURL: baseUrl
    };

    const instance: AxiosInstance = axios.create(requestOptions);

    instance.interceptors.request.use(
        request => request,
        requestError => Promise.reject(requestError)
    );

    instance.interceptors.response.use(
        (response: AxiosResponse<T>) => response,
        (responseError: AxiosError<T>) => {
            console.warn('Live4.tv response error', responseError);

            if (responseError.response?.status !== undefined
                && [401, 403].includes(responseError.response?.status)
            ) {
                store.dispatch(setIsLoggedIn(false));

                return Promise.reject(responseError);
            } else {
                if (responseError.response) {
                    throw responseError.response.data;
                } else {
                    return Promise.reject(responseError);
                }
            }
        }
    );

    return instance;
};
